export default {"src":"/_next/static/media/sunbathing-chair.a3ec49f3.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};